import { generateEventColors } from "@/theme/utils";

export function setAuthorization(state, { token, accessCode }) {
  state.token = token || null;
  state.accessCode = accessCode || null;
}

export function setEvent(state, event) {
  const lpSettings = JSON.parse(event.lp_settings);
  const eventColors = lpSettings.theme || generateEventColors(event);

  state.slug = event.lp_url;
  state.eventId = event.id;
  state.appId = event.app_id;
  state.timezone = event.timezone;
  state.settings = lpSettings;
  state.eventColors = eventColors;
}

export function setLpMode(state, lpMode) {
  state.lpMode = lpMode;
}

export function setConstantComponentId(state, componentId) {
  state.constantComponentId = componentId;
}

export function setComponentIdsWithRatingAlwaysEnabled(state, componentIdsWithRatingAlwaysEnabled) {
  state.componentIdsWithRatingAlwaysEnabled = componentIdsWithRatingAlwaysEnabled;
}

export function updateCurrentTime(state) {
  state.currentTime = new Date();
}

export function setRequestRefreshToken(state, isRequesting) {
  state.requestRefreshToken = isRequesting;
}

export function setCurrentLocale(state, locale) {
  state.locale = locale;
}

export function setTheme(state, theme) {
  state.theme = theme;
}

export function setHideSessionTime(state, hideSessionTime) {
  state.hideSessionTime = hideSessionTime;
}

export function setShowLiveIndicator(state, showLiveIndicator) {
  state.showLiveIndicator = showLiveIndicator;
}

export function setHideLiveStreamButtons(state, hideLiveStreamButtons) {
  state.hideLiveStreamButtons = hideLiveStreamButtons;
}

export function setSessionRatings(state, sessionRatings) {
  state.sessionRatings = sessionRatings;
}

export function setCustomSponsor(state, customSponsor) {
  state.customSponsor = customSponsor;
}

export function setSpeakersCountOnPreview(state, speakersCountOnPreview) {
  state.speakersCountOnPreview = speakersCountOnPreview;
}

export function setHighlightedSessionIds(state, highlightedSessionIds) {
  state.highlightedSessionIds = highlightedSessionIds;
}

export function setSessionTimeWithDate(state, sessionTimeWithDate) {
  state.sessionTimeWithDate = sessionTimeWithDate;
}

export function setPreselectedPathIds(state, pathIds) {
  state.preselectedPathIds = pathIds;
}

export function setPreselectedPlaceIds(state, placeIds) {
  state.preselectedPlaceIds = placeIds;
}

export function setPreselectedDayId(state, dayId) {
  state.preselectedDayId = dayId;
}

export function setQuestionsDisabled(state, questionsDisabled) {
  state.questionsDisabled = questionsDisabled;
}
